<template><section>
<div class="page">
  <div>
    <h2>Sending media, documents, location and contacts</h2>
    <h3>Sharing media, documents, location or contacts</h3>
    <ol>
      <li>Open a chat.</li>
      <li>Tap “+” button.</li>
      <li>Choose what you wish to send:</li>
      <ol type="a">
        <li>Choose File to select a document from your phone.</li>
        <li>Choose Gallery to select an existing photo or video from your phone. You can tap and hold to select multiple
          images.
        </li>
        <li>Choose Camera to take a picture with your camera.</li>
        <li>Choose Location to send your location or a nearby place.</li>
        <li>Choose Name Card to send contacts.</li>
        <li>Choose Event to send a note.</li>
      </ol>
      <li>Tap Send.</li>
    </ol>
    <h6><i>Note: The maximum allowed document size is 500 MB. In order to send a document from within ToTok, the
      document must be saved locally on your phone.
    </i></h6>
    <h3>Forwarding media, documents, locations or contacts</h3>
    <p>To forward media, documents, locations or contacts from one conversation to another:
    </p>
    <ol>
      <li>Open a chat.</li>
      <li>Tap and hold the type of message you wish to forward. You can select multiple messages.
      </li>
      <li>Tap Forward.</li>
      <li>Choose the chat you wish to forward the message to.</li>
      <li>Tap Send.</li>
    </ol>
    <p>When you forward media, documents, locations or contacts, you don't have to upload it again, and therefore it
      will send faster and use less data.
    </p>


  </div>
</div>
 </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
